var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8854",
    "data-name": "Group 8854",
    transform: "translate(-0.195 -0.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 20,
    height: 20,
    transform: "translate(0.195 0.195)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8846",
    "data-name": "Group 8846",
    transform: "translate(0.696 -0.304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 18,
    height: 18,
    transform: "translate(0.499 0.499)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8368",
    "data-name": "Group 8368",
    transform: "translate(0.168 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M3089.448,2751.144v-5.6h-.221c-.992,0-1.983,0-2.975,0a1.126,1.126,0,0,1-.352-.049.6.6,0,0,1-.389-.637.614.614,0,0,1,.547-.553,1.317,1.317,0,0,1,.161-.006h7.723a.63.63,0,0,1,.7.529.607.607,0,0,1-.476.695,1.334,1.334,0,0,1-.267.022q-1.488,0-2.974,0h-.211v5.6c.17,0,.341,0,.511,0a.616.616,0,0,1,.659.607.6.6,0,0,1-.616.63q-1.191.02-2.382,0a.6.6,0,0,1-.611-.635.616.616,0,0,1,.647-.6C3089.091,2751.141,3089.264,2751.144,3089.448,2751.144Z",
    transform: "translate(-3080.906 -2741.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M3239.325,2699.744c-.1-.006-.189-.008-.276-.018a.619.619,0,0,1,.052-1.236c.848,0,1.7-.015,2.544,0a1.049,1.049,0,0,0,1.146-.78,6.5,6.5,0,0,0,.289-1.285c.161-1.062.295-2.128.444-3.191a.626.626,0,1,1,1.235.174q-.262,1.87-.523,3.74a3.44,3.44,0,0,1-.9,1.967.269.269,0,0,0-.043.2c.193,1.038.394,2.074.591,3.111a.633.633,0,0,1-.49.814.653.653,0,0,1-.733-.592c-.177-.926-.359-1.85-.53-2.777-.023-.125-.074-.152-.187-.15-.394.005-.789.007-1.183,0-.123,0-.174.029-.2.159-.168.909-.346,1.816-.521,2.724-.009.047-.019.094-.03.14a.621.621,0,1,1-1.215-.256c.058-.323.124-.645.187-.967Z",
    transform: "translate(-3226.423 -2692.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M2996.309,2699.771c.092.481.181.948.272,1.415.085.445.175.889.257,1.335a.62.62,0,1,1-1.214.246c-.184-.918-.353-1.839-.536-2.758-.057-.286.012-.245-.3-.247-.353,0-.705.007-1.057,0-.158-.005-.21.047-.238.2-.166.909-.344,1.816-.517,2.724a.634.634,0,0,1-.781.581.618.618,0,0,1-.454-.744c.2-1.054.4-2.108.6-3.164a.269.269,0,0,0-.04-.2,3.668,3.668,0,0,1-.937-2.161q-.236-1.765-.488-3.528a.646.646,0,0,1,.277-.687.606.606,0,0,1,.69.018.67.67,0,0,1,.268.487q.254,1.853.51,3.706a2.569,2.569,0,0,0,.35,1.025.98.98,0,0,0,.886.506q1.326-.006,2.652,0a.618.618,0,0,1,.6.884.632.632,0,0,1-.612.36C2996.442,2699.763,2996.384,2699.767,2996.309,2699.771Z",
    transform: "translate(-2990.868 -2692.675)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTable);
export default __webpack_public_path__ + "static/media/white_table.c65aafc6fbcb0cab064904544610bb4e.svg";
export { ForwardRef as ReactComponent };